export const COLORS = {
  accent: "accent",
  neutral: "neutral",
  positive: "positive",
  negative: "negative",
  warning: "warning",
} as const;
